export const SET_PALTEL_CUSTOMER_INFO = 'SET_PALTEL_CUSTOMER_INFO'
export const FAILED_SET_PALTEL_CUSTOMER_INFO = 'FAILED_SET_PALTEL_CUSTOMER_INFO'
export const GET_NOTIFICATIONS_LIST = 'SET_NOTIFICATIONS_LIST'
export const SET_ACCESS_PAGE_LIST = 'SET_ACCESS_PAGE_LIST'
export const SET_ACTIVE_SERVICES = 'SET_ACTIVE_SERVICES'
export const SET_RECONNECTION_ELIGBLE_SERVICES =
  'SET_RECONNECTION_ELIGBLE_SERVICES'
export const SET_INSTALLMENT_DETAILS = 'SET_INSTALLMENT_DETAILS'
